import React from 'react'
import styled from 'styled-components'
import AboutUsCard from './AboutUsCard'
// Swiper
import 'swiper/css'
import 'swiper/css/navigation'
import { A11y, Autoplay, Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import Responsive from '../assets/config/Responsive'
import ShortLeftArrow from '../assets/icons/JSX/ShortLeftArrow'
import ShortRightArrow from '../assets/icons/JSX/ShortRightArrow'
import Colors from '../assets/styles/Colors'
import { Container } from '../assets/styles/GlobalStyle'
import { useAppSelector } from '../store'
import { AppState } from '../store/appSlice'
//
//
interface NavButtonProps {
  children: React.ReactNode
  className?: string
}
//
const AboutUsSwiper: React.FC<{
  style?: React.CSSProperties
}> = ({ style }) => {
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  // What People Say fake data
  const FakeWhatPeopleSay = [
    {
      star: 5,
      type: 'message',
      image: 'https://cdn-icons-png.flaticon.com/512/21/21104.png',
      translations: {
        ge: {
          title: 'მარიამი',
          type: 'მომხმარებელი',
          body: 'ფრანის პლატფორმით სარგებლობა ძალიან მარტივია, ნავიგაცია იოლი, ნებისმიერი ტიპის მომხმარებელი შეძლებს მასზე მორგებული სადაზღვევო პოლისის მოძიებას',
        },
        en: {
          title: 'Mariam',
          type: 'Customer',
          body: 'The platform is very user friendly as the navigation is simple and any user can discover a tailor-made insurance policy that suits their needs.',
        },
      },
    },
    {
      star: 5,
      type: 'message',
      image: 'https://cdn-icons-png.flaticon.com/512/21/21104.png',
      translations: {
        ge: {
          title: 'თენგო',
          type: 'მომხმარებელი',
          body: 'საუკეთესო პირობის მისაღებად სხვადასხვა სადაზღვევო კომპანიების შემოთავაზების განხილვა მიწევდა, ახლა ეს ერთ სივრცეშია შესაძლებელი. Good Job',
        },
        en: {
          title: 'Tengo',
          type: 'Customer',
          body: "It's no longer necessary to contact multiple insurance companies to find the best deal – you can now compare offers from various providers within a single platform.",
        },
      },
    },
    {
      star: 5,
      type: 'message',
      image: 'https://cdn-icons-png.flaticon.com/512/21/21104.png',
      translations: {
        ge: {
          title: 'ნიკო',
          type: 'მომხმარებელი',
          body: 'მომწონს სადა და მარტივი დიზაინი. რაც მთავარია სხვა კომპანიებისგან განსხვავებით აქ ჩათი მუშაობს და ადეკვატურად გიბრუნებენ პასუხებს.  კმაყოფილი ვარ მომსახურებით..',
        },
        en: {
          title: 'Niko',
          type: 'Customer',
          body: 'I appreciate the easy-to-use design and helpful chat. I am content with the service.',
        },
      },
    },
    {
      star: 5,
      type: 'message',
      image: 'https://cdn-icons-png.flaticon.com/512/21/21104.png',
      translations: {
        ge: {
          title: 'თიკო',
          type: 'მომხმარებელი',
          body: 'არ მიყვარს გაუგებარი ხელშეკრულებების წაკითხვა, აქ ყველა პირობა გასაგები იყო, თუ რას მინაზღაურებს და რას არა.',
        },
        en: {
          title: 'Tiko',
          type: 'Customer',
          body: "I dislike dealing with confusing contracts, however here all the terms were transparent, clearly outlining what will be reimbursed and what won't.  ",
        },
      },
    },
    {
      star: 5,
      type: 'message',
      image: 'https://cdn-icons-png.flaticon.com/512/21/21104.png',
      translations: {
        ge: {
          title: 'მაიკო',
          type: 'მომხმარებელი',
          body: 'კარგია <3',
        },
        en: {
          title: 'Maiko',
          type: 'Customer',
          body: 'Good <3',
        },
      },
    },
  ]
  //
  //
  const brakePoints = {
    1200: {
      slidesPerView: 2,
      spaceBetween: 24,
    },
    1350: {
      slidesPerView: 2,
      spaceBetween: 24,
    },
    1650: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  }
  //
  //
  return (
    <ReplacedContainer>
      <Wrapper>
        <Swiper
          breakpoints={brakePoints}
          slidesPerView="auto"
          scrollbar={{ draggable: true }}
          modules={[Autoplay, A11y, Navigation]}
          loop={FakeWhatPeopleSay.length > 1}
          navigation={{
            enabled: false,
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }}
          autoplay={{
            delay: 4000,
            pauseOnMouseEnter: true,
            disableOnInteraction: true,
          }}
        >
          {FakeWhatPeopleSay.map((item: any, index: number) => {
            return (
              <SwiperSlide key={index}>
                <Card>
                  <AboutUsCard
                    key={index}
                    img={item.image}
                    // @ts-ignore
                    itemTitle={item?.translations?.[lang]?.title as any}
                    // @ts-ignore
                    itemBody={item?.translations?.[lang]?.body}
                    // @ts-ignore
                    itemJobDescription={item?.translations?.[lang]?.type}
                    date={''}
                    startValue={item.star}
                  />
                </Card>
              </SwiperSlide>
            )
          })}
        </Swiper>

        <NavigationButtons>
          <NavButton className="swiper-button-prev">
            <ShortLeftArrow />
          </NavButton>

          <NavButton className="swiper-button-next">
            <ShortRightArrow />
          </NavButton>
        </NavigationButtons>
      </Wrapper>
    </ReplacedContainer>
  )
}
//
//
// styles
const Card = styled.div`
  ${Responsive.tablet} {
    max-width: unset;
  }
`
const NavButton = styled.div<NavButtonProps>`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: ${Colors.white};
  box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.04);
  cursor: pointer;

  svg {
    color: ${Colors.nevadaGrey};
    height: 18px;
  }
`
const NavigationButtons = styled.div`
  .swiper-button-prev,
  .swiper-button-next {
    z-index: 5 !important;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background-color: ${Colors.white};
    box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.04);
    cursor: pointer;

    svg {
      color: ${Colors.nevadaGrey};
      height: 18px;
    }
  }

  ${Responsive.tablet} {
    display: none;
  }

  ${Responsive.mobile} {
    display: none;
  }
`
const ReplacedContainer = styled(Container)`
  position: relative;

  ${Responsive.tablet} {
    max-width: unset;
    margin-left: 48px;
    margin-right: unset;
  }

  ${Responsive.mobile} {
    max-width: unset;
    margin-right: unset;
  }
`
const Wrapper = styled.div`
  position: relative;
  width: 100%;
  padding-inline: 96px;

  .swiper-slide {
    height: unset;
  }

  .swiper-button-prev::after {
    display: none;
  }
  .swiper-button-next::after {
    display: none;
  }

  ${Responsive.tablet} {
    padding-inline: 0;
    width: 100vw;
    /*  */
    .swiper-slide {
      width: unset;
      margin-right: 24px;
    }

    .service-card {
      width: 296px;
    }
  }

  ${Responsive.mobile} {
    padding-inline: 0;
    width: 100vw;
    /*  */
    .swiper-slide {
      width: unset;
      margin-right: 24px;
    }

    .service-card {
      width: 260px;
    }
  }
`
export default AboutUsSwiper
